export const getCurrentSearch = state => state.searches.currentSearch
export const getCurrentSearchFilters = state => state.searches.currentSearch.filters
export const getCurrentSearchResults = state => state.searches.currentSearch.applications
export const getSearchesData = state => state.searches.data
